import { Linkable } from "@/components/blocks/Linkable";
import { useReturnReasons, useReturnRegister } from "@/data/Content/RegisterReturn";
import { ContentContext } from "@/data/context/content";
import { useLocalization } from "@/data/Localization";
import {  Button, FormControl, Grid, InputLabel, MenuItem, Paper, Select, Stack, Typography } from "@mui/material";
import { FC, useContext, useEffect, useState } from "react";
import { EMPTY_STRING } from "../../USPsDeliveryTerms";
import { ReturnOrderFormContainerSX, SelectReasonFormSX } from "../styles/returnOrder";

export const SelectReturnReason: FC = () => {

    const returnOrderNLS = useLocalization('ReturnOrder');

    const {
        subitReturnToOMS,
        setActiveReturnStep,
        returnSteps,
        selectedReturnReason,
		setSelectedReturnReason
    } = useContext(ContentContext) as ReturnType<typeof useReturnRegister>;
    const { reasons } = useReturnReasons();

    const [errors, setErrors] = useState<Record<string,string>>({});

    useEffect(()=>{
        setSelectedReturnReason(""); // Resetting the previously selected value on load of this content
    },[]);

    const validateAndSubmit = () => {
        const tempErrors:Record<string,string> = {};
        if(selectedReturnReason===EMPTY_STRING){
            tempErrors.form_error = returnOrderNLS.Errors.ERROR_RETURN_REASON_EMPTY.t();
		}
        setErrors(tempErrors);
        if(Object.keys(tempErrors).length===0){
            subitReturnToOMS();
        }
    }

    return (
        <Paper sx={ReturnOrderFormContainerSX}>
            <Stack mb={1}>
                <Typography variant="body1AsH1" fontSize={16}>
                    {returnOrderNLS.ReasonSelect.selectItemText.t()}
                </Typography>
            </Stack>
            <Grid sx={SelectReasonFormSX}>
                <Grid container spacing={3}>
                    <Grid item xs={12} md={6}>
                        <Typography fontWeight='bold' mb={1}>
                            {returnOrderNLS.ReasonSelect.ReturnReasonQuestion.t()}
                        </Typography>
                        <FormControl fullWidth variant="outlined">
                            <InputLabel id="return-reason-select-label">
                                {returnOrderNLS.ReasonSelect.hyphens.t()}
                            </InputLabel>
                            <Select 
                                id="return-reason-select"
                                name="returnReason"
                                fullWidth 
                                value={selectedReturnReason}
                                onChange={(event)=>setSelectedReturnReason(event.target.value)}
                            >
                                {Object.keys(reasons).length>0 && Object.keys(reasons).map(r =>
                                    <MenuItem value={r} key={r}>{reasons[r]}</MenuItem>
                                )}
                            </Select>
                            {errors.form_error && 
                                <Stack mt={1}>
                                    <Typography color="red" variant="body1AsH2">{errors.form_error}</Typography>
                                </Stack>
                            }
                        </FormControl>
                    </Grid>
                </Grid>
                <Grid container spacing={3}>
                    <Grid item xs={12} md={3}>
                        <Linkable
                            onClick={() => setActiveReturnStep(returnSteps.selectProduct)}
                            type="button"
                            variant="outlined"
                            id="return-order-step-back-button"
                            data-testid="return-order-step-back-button"
                            sx={{width:'100%' }}
                        >
                            {returnOrderNLS.Labels.Back.t()}
                        </Linkable>
                    </Grid>
                    <Grid item xs={12} md={3}>
                        <Button
                            fullWidth
                            data-testid="return-reason-submit-button"
                            id="return-reason-submit-button"
                            type="submit"
                            variant="contained"
                            color="primary"
                            onClick={validateAndSubmit}
                        >
                            {returnOrderNLS.Labels.SelectReasonSubmit.t()}
                        </Button>
                    </Grid>
                </Grid>
            </Grid>
        </Paper>
    );
};